/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiCreateAlertDecisionRulesCommandRule } from './InternalApiCreateAlertDecisionRulesCommandRule';
import {
    InternalApiCreateAlertDecisionRulesCommandRuleFromJSON,
    InternalApiCreateAlertDecisionRulesCommandRuleFromJSONTyped,
    InternalApiCreateAlertDecisionRulesCommandRuleToJSON,
    InternalApiCreateAlertDecisionRulesCommandRuleToJSONTyped,
} from './InternalApiCreateAlertDecisionRulesCommandRule';

/**
 * overwrites all existing decision rules based on org_id and entity_type
 * @export
 * @interface InternalApiCreateAlertDecisionRulesCommand
 */
export interface InternalApiCreateAlertDecisionRulesCommand {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiCreateAlertDecisionRulesCommand
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {Array<InternalApiCreateAlertDecisionRulesCommandRule>}
     * @memberof InternalApiCreateAlertDecisionRulesCommand
     */
    rules: Array<InternalApiCreateAlertDecisionRulesCommandRule>;
}



/**
 * Check if a given object implements the InternalApiCreateAlertDecisionRulesCommand interface.
 */
export function instanceOfInternalApiCreateAlertDecisionRulesCommand(value: object): value is InternalApiCreateAlertDecisionRulesCommand {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function InternalApiCreateAlertDecisionRulesCommandFromJSON(json: any): InternalApiCreateAlertDecisionRulesCommand {
    return InternalApiCreateAlertDecisionRulesCommandFromJSONTyped(json, false);
}

export function InternalApiCreateAlertDecisionRulesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateAlertDecisionRulesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'rules': ((json['rules'] as Array<any>).map(InternalApiCreateAlertDecisionRulesCommandRuleFromJSON)),
    };
}

export function InternalApiCreateAlertDecisionRulesCommandToJSON(json: any): InternalApiCreateAlertDecisionRulesCommand {
    return InternalApiCreateAlertDecisionRulesCommandToJSONTyped(json, false);
}

export function InternalApiCreateAlertDecisionRulesCommandToJSONTyped(value?: InternalApiCreateAlertDecisionRulesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'rules': ((value['rules'] as Array<any>).map(InternalApiCreateAlertDecisionRulesCommandRuleToJSON)),
    };
}

